import { Component, OnInit, Input } from '@angular/core';
import { SwiperConfigInterface, SwiperFadeEffectInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-main-carousel',
  templateUrl: './main-carousel.component.html',
  styleUrls: ['./main-carousel.component.scss']
})
export class MainCarouselComponent implements OnInit {
  @Input('slides') slides: Array<any> = [];
 
  public config: SwiperConfigInterface = {};

  // private pagination: SwiperPaginationInterface = {
  //   el: '.swiper-pagination',
  //   clickable: true
  // };
  private SwiperFadeEffectInterface: SwiperFadeEffectInterface = {
    crossFade: true
  }
  dynamicContent: string = 'MILK';
  contents: string[] = ['MILK','Eggs', 'Butter', 'Yocurt', 'CHEESE', 'Produce', 'Beef', 'Poultry', 'PORK'];
  currentIndex: number = 0;
  
  constructor() { }

  ngOnInit() { 
    setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.contents.length;
      this.dynamicContent = this.contents[this.currentIndex];
    }, 800);
  }

  ngAfterViewInit(){
    this.config = {
      slidesPerView: 1,
      spaceBetween: 0,         
      keyboard: true,
      navigation: true,
      // pagination: this.pagination,
      grabCursor: true,        
      loop: true,
      preloadImages: false,
      lazy: true,     
      autoplay: false,
      speed: 800,
      effect: "fade"
      
    }
  }

}